<form [formGroup]="classRoomForm">
    <h4 class="text-medium-blue font-weight-bold font-size-20">Classroom Setting</h4>

    <div class="font-weight-bold">Select one</div>
    <div *ngFor="let type of schools | keyvalue: originalOrder" class="form-check py-3">
        <input
            type="radio"
            formControlName="teacherType"
            class="form-check-input"
            [id]="type.key"
            [value]="type.key"
        />
        <label class="form-check-label" [for]="type.key"> {{ type.value }} </label>

        <!-- Add dropdown components only for public teacher type -->
        <ng-container *ngIf="type.key === SCHOOL_TYPE.PUBLIC_SCHOOL">
            <ng-template appAddHost></ng-template>
        </ng-container>
    </div>
</form>
